import { BagStatus } from '../bags/graphql/types/BagTagType';
import { BatchStage, BatchStatus, CreationMethod } from './types';

/** 批次创建超过该小时数仍未完结，数据停止更新 */
export const FREEZE_HOURS = 72;

export const BATCH_STATUSES: BatchStatus[] = ['CREATED', 'SORTING', 'SORTING_ENDED', 'COMPLETED', 'CANCELLED'];

/** 仍可新增包牌 / 装包 / 结束分拣的状态 */
export const ACTIVE_STATUSES: BatchStatus[] = ['CREATED', 'SORTING'];

/** 已结束分拣或终态：不能新增包牌、不能结束分拣 */
export const CLOSED_STATUSES: BatchStatus[] = ['SORTING_ENDED', 'COMPLETED', 'CANCELLED'];

/** 不能作为移入目标的状态 */
export const MOVE_IN_BLOCKED_STATUSES: BatchStatus[] = ['CANCELLED', 'COMPLETED', 'SORTING_ENDED'];

export const BATCH_STAGES: BatchStage[] = [0, 1, 2, 3, 4];

/** 阶段列是否展示车次数 */
export const STAGE_HAS_TRUCKS: Record<BatchStage, boolean> = { 0: false, 1: false, 2: true, 3: true, 4: true };

export const CREATION_METHODS: CreationMethod[] = ['SORTER', 'MANUAL'];

export const BAG_STATUSES: BagStatus[] = [BagStatus.NOT_USED, BagStatus.USED, BagStatus.DISCARDED, BagStatus.HANDOVER, BagStatus.CLOSED];

export const STATUS_COLORS: Record<BatchStatus, { color: string; background: string }> = {
    CREATED: { color: '#4e5969', background: '#f2f3f5' },
    SORTING: { color: '#722ed1', background: '#f3eafe' },
    SORTING_ENDED: { color: '#b06a00', background: '#fff7e8' },
    COMPLETED: { color: '#0d7a3d', background: '#e8f8ee' },
    CANCELLED: { color: '#f5222d', background: '#fff1f0' },
};

const BAG_USED_COLOR = { color: '#722ed1', background: '#f7f3ff', border: '#e9dcff' };

/** 已交接与已使用同色 */
export const BAG_STATUS_COLORS: Record<BagStatus, { color: string; background: string; border: string }> = {
    [BagStatus.NOT_USED]: { color: '#86909c', background: '#f7f8fa', border: '#e5e6eb' },
    [BagStatus.USED]: BAG_USED_COLOR,
    [BagStatus.DISCARDED]: { color: '#c9cdd4', background: '#f7f8fa', border: '#e5e6eb' },
    [BagStatus.HANDOVER]: BAG_USED_COLOR,
    [BagStatus.CLOSED]: { color: '#c26b00', background: '#fff7e8', border: '#ffd8a8' },
};

export const CREATION_METHOD_COLORS: Record<CreationMethod, { color: string; background: string }> = {
    SORTER: { color: '#165dff', background: '#e8f3ff' },
    MANUAL: { color: '#4e5969', background: '#f2f3f5' },
};

/** 列表默认分页 */
export const DEFAULT_PAGE_SIZE = 100;
export const PAGE_SIZE_OPTIONS = ['20', '50', '100'];

/** 装车分组：每车最多包牌数（mock） */
export const BAGS_PER_TRUCK = 5;

/** 每磅估算重量系数（mock：每件包裹 2.7 磅） */
export const LB_PER_PARCEL = 2.7;

/** 列表 / 详情时间展示格式 */
export const DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm';
export const DATE_TIME_SECONDS_FORMAT = 'YYYY/MM/DD HH:mm:ss';

// ---------------------------------------------------------------- 延期功能开关
// 2026-10-14 用户决定以下功能延期（plan D12、§4.10）：设为 false 时隐藏，代码保留、仍参与类型检查。

/** 创建包牌的「自定义」规则（规则编辑器 CustomCodeRuleEditor）。恢复条件：产品确认自定义规则需求后置为 true */
export const ENABLE_CUSTOM_BAG_RULES = false;

/**
 * 移入批次的包裹移入（包裹分组、目标包牌选择、移入时新建包牌、待新建包牌校验）。
 * 关闭时移入只处理包牌，输入的包裹号列入「无法移入」（原因：暂只支持包牌移入）；移出批次不受影响。
 */
export const ENABLE_PARCEL_MOVE_IN = false;

/** 装载明细抽屉。列表 5 列阶段统计已删除（改由数据组在 BI 看板实现），抽屉失去入口；恢复时需另加入口 */
export const ENABLE_LOAD_DETAIL = false;

/** 下载：批次详情「下载批次明细」、包牌详情「下载包牌快照」。是否有必须保留的下载待评估 */
export const ENABLE_DOWNLOADS = false;
